import FeatureFlags from 'garaje/services/feature-flags';

import type { TrafficType } from './splitio';

export default class LocationFeatureFlags extends FeatureFlags {
  trafficType: TrafficType = 'location';
}
